import {RootState} from 'src/store/rootReducer';

export const getRole = (state: RootState) =>
  state.user.detail?.is_admin || false;

export const getName = (state: RootState) => state.user.detail?.full_name;
